<div class="header-container" [ngClass]="{ 'loading-mode': utilities.fullPageLoading}">
    <mat-toolbar>
        <mat-toolbar-row
            [ngClass]="{ 'header-background': utilities.isSelectClientRoute() || utilities.isOnboardingRoute() } "
            class="space-between">
            <ng-container *ngIf="isSelectClientRoute; else notSelectClient">
                <img class="close-logo" *ngIf="showlogo" src="assets/images/Fraud Deflect_logo_simple.png" />
                <p class="email-font">Welcome, {{ userEmail }}</p>
                <span></span>
            </ng-container>

            <ng-template #notSelectClient>
                <ng-container *ngIf="utilities.isOnboardingRoute(); else outsideOnboardingRoutes">
                    <img class="close-logo" src="assets/images/Fraud Deflect_logo_simple.png" />
                    <span>
                        <p class="email-font">Welcome to your Onboarding Process</p>
                    </span>
                </ng-container>
                <ng-template #outsideOnboardingRoutes>
                    <ng-container *ngIf="isOnboarding && isFdUser; else maybeOnboardingNonFd">
                        <img class="close-logo" src="assets/images/Fraud Deflect_logo_simple.png" />
                    </ng-container>
                    <ng-template #maybeOnboardingNonFd>
                        <ng-container *ngIf="isOnboarding; else defaultHeader">
                            <img class="close-logo" src="assets/images/Fraud Deflect_logo_simple.png" />
                            <span>
                                <p class="email-font">Welcome, {{ userEmail }}</p>
                            </span>
                        </ng-container>
                        <ng-template #defaultHeader>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </ng-template>

            <div [ngClass]="{ 'menu-closed': showlogo, 'menu-opened': !showlogo }" class="toolbar-center">
                <div [ngClass]="{ 'company-name-container-clients': !isUniqueClient && !utilities.isOnboardingRoute(),
                 'company-name-container': isUniqueClient && !utilities.isOnboardingRoute(),
                'company-name-container-clients-onboarding':utilities.isOnboardingRoute() 
             }" *ngIf="!utilities.isSelectClientRoute() && !utilities.isGlobalRoute() && clientId && companyName"
                    [matTooltipDisabled]="isUniqueClient" [matTooltip]="languageSelectTooltip"
                    (click)="redirectSelectClient()">
                    <p class="menu-text">{{clientId}} - {{companyName}}</p>
                    <span [ngClass]="{'icon-onboarding': utilities.isOnboardingRoute()}" class="change-icon"
                        *ngIf="!isUniqueClient && companyName">
                        <mat-icon [ngClass]="{'icon-onboarding': utilities.isOnboardingRoute()}"
                            class=icon-size>autorenew</mat-icon>
                    </span>
                </div>
                <div class="company-name-container-clients" *ngIf="utilities.isGlobalRoute()"
                    [matTooltip]="'Back to Select Client'" (click)="redirectSelectClient()">
                    <p class="menu-text">Return to Select Client</p>
                    <span class="change-icon">
                        <mat-icon class=icon-size>autorenew</mat-icon>
                    </span>
                </div>
            </div>
            <span class="right-items">
                <div class="demo-buttons-container">
                    <button *ngIf="utilities.isDemoOnbValue && utilities.isSelectClientRoute()"
                        (click)="createOnbClient()" mat-raised-button> Demo Merchant Onboarding Wizard
                    </button>
                    <button *ngIf="utilities.isDemoOnbValue && utilities.isSelectClientRoute()"
                        (click)="createAcquirerOnbClient()" mat-raised-button> Demo Acquirer Onboarding Wizard
                    </button>
                </div>
                <button *ngIf="isSelectClientRoute   || utilities.isOnboardingRoute()" mat-icon-button
                    class="profile-menu-btn" (click)="toggleTheme()"
                    [matTooltip]="isDarkMode ? 'Light Mode' : 'Dark Mode'">
                    <mat-icon
                        [ngClass]="{ 'icon-color-header': utilities.isSelectClientRoute() || utilities.isOnboardingRoute()}">
                        {{ isDarkMode ? 'light_mode' : 'dark_mode' }}
                    </mat-icon>
                </button>
                <app-language-selector></app-language-selector>
                <app-global-menu *ngIf="isFdUser"></app-global-menu>
                <app-profile-menu class="space-container"></app-profile-menu>
            </span>
        </mat-toolbar-row>
    </mat-toolbar>
</div>